// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {GraphcardCommonLayout} from 'app_components/commons/graphcard'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
// @end

// @import types
// @end

// @ADD Component types
interface IGraphcardCommonProps {
  title?: string,
  type: 'bars' | 'line' | 'progress'
  data: any
  options?: any
}
interface IGraphcardCommonState {
  typeGraph: 'bars' | 'line' | 'progress'
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class GraphcardCommon extends Component<IGraphcardCommonProps, IGraphcardCommonState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IGraphcardCommonProps) {
    super(props)
    this.state = {
      typeGraph: 'bars'
    }
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    if (this.props.type) {
      this.setState({typeGraph: this.props.type})
    }
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  render() {
    return(
      <GraphcardCommonLayout
        {...this.props}
        type={this.state.typeGraph}
      />
    )
  }
}

export default connect(mapStatesToProps)(GraphcardCommon)
